module.exports = __webpack_public_path__ + "img/draw-p.8f01145c.png";